import React, { useState, useEffect } from 'react'
import { get, map } from 'lodash'
import { logOut } from 'apis/index'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl
} from '@mui/material'
import { galleryList } from '../../v2_actions/gallery'
import { makeStyles } from '@material-ui/core/styles'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import { getLoggedInUserDisplayName } from '../../v2_actions/auth'
import { briefGalleryList } from 'v2_actions/brief_gallery'

const useStyles = makeStyles((theme) => ({
  container: {
    zIndex: 99,
    alignItems: "center",
    justifyContent: "space-between",
  },
  accountDetailWrapper: {
    display: "flex",
    alignItems: "center",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: 18,
    justifyContent: "space-between",
  },
  accountDetail: {
    display: "flex",
    alignItems: "center",
    textAlign: "left",
    marginRight: "50px",
    marginTop: "10px",
    fontSize: "16px",
    color: "#00000",
  },
  logo: {
    paddingLeft: "0",
    margin: "0",
    fontSize: "18px",
  },
  logo_img: {
    width: "150px",
    marginRight: "100px",
    height: "34px",
  },
  title: {
    fontSize: 12,
    display: "flex",
    marginTop: "0px",
    marginBottom: "0px",
  },
  signOut: {
    marginLeft: 30,
    cursor: "pointer",
    fontSize: 12,
    marginTop: "-3px",
  },
  accountCircle: {
    marginRight: "5px",
    color: "#00000",
  },
  mainWrapper : {
    display: 'block',
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  galleryDropdown: {
    height: 30,
    fontSize: 12
  }
}));

export const TopMenuBar = ({ gallery, width, title }) => {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const displayName = getLoggedInUserDisplayName()
  const [galleryId, setGalleryId] = useState()
  const showMenu = useSelector((state) => state.user.showMenu)
  const galleries = useSelector(() => briefGalleryList.getVisibleObjects());

  useEffect(() => {
    // Use 'all' filter to fetch all galleries for the dropdown selector
    dispatch(briefGalleryList.updateListFilter({ all: true }))
    dispatch(briefGalleryList.fetchListIfNeeded(true));
  }, [])

  useEffect(() => {
    setGalleryId(get(gallery, 'id'))
  }, [gallery])

  const signOut = () => {
    logOut()
    history.push(`/photographer/login`)
  }

  const handleGalleryChange = (event) => {
    setGalleryId(event.target.value)
    history.push(`/photographer/gallery/${event.target.value}/view`)
  }

  return (
    <div>
      <Grid container className={classes.container}>
        <Grid item xs={ 1 }></Grid>
        {title &&
         <Box my={ 2 } sx={{ minWidth: 260, display: 'flex', alignItems: 'center', gap: '10px' }}>
           <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#000', margin: 0 }}>Gallery</label>
           <FormControl fullWidth size='small'>
             <select
               label='Gallery'
               value={ galleryId }
               onChange={ handleGalleryChange }
               className={ classes.galleryDropdown}
             >
               {map(galleries, (gallery) =>
                 <option value={get(gallery, 'id')}>
                   { get(gallery, 'gallery_name') }
                 </option>
               )}
             </select>
           </FormControl>
         </Box>
        }
        <div>
          <Grid item xs={12} className={classes.mainWrapper}>
              <div className={classes.accountDetailWrapper}>
                <div
                  onClick={() => history.push(`/photographer/editdetails`)}
                  className={classes.accountDetail}
                >
                  <AccountCircleIcon className={classes.accountCircle} />
                  <span>{displayName}</span>
                </div>
              </div>
              <div className={classes.signOut} onClick={() => signOut()}>
                <span>Sign out</span>
              </div>
          </Grid>
        </div>
      </Grid>
    </div>
  );
};
